'use strict';

import uuid from 'uuid';

/**
 * @property {String} id
 */
export default class Request {
  constructor() {
    this.id = uuid.v4();
  }
}